import { ReadAccess } from 'src/app/AppAuth/ReadAccess'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import React from 'react'
import {
  ShowPageBody,
  ShowPageItem,
} from '../../../components/PageLayout/ShowPage'
import { ServicesDescriptionContainer } from '../services.styles'
import {
  ProviderSection,
  ReceptorSection,
  ServiceInstancesSection,
  ServiceRolesSection,
} from '../services.components'

export const ServicesShowPageContent = (): JSX.Element => (
  <ShowPageItem>
    <ShowPageBody>
      <ServicesDescriptionContainer>
        <ServiceRolesSection />
        <ReadAccess capabilities={[CAPABILITY.CAN_VIEW_RECEPTORS]}>
          <ReceptorSection />
        </ReadAccess>
        <ProviderSection />
        <ServiceInstancesSection />
      </ServicesDescriptionContainer>
    </ShowPageBody>
  </ShowPageItem>
)
